(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('DevisDialogController', DevisDialogController);

    DevisDialogController.$inject = ['$uibModalInstance', '$translate', 'contract', 'devisId', 'readOnly', 'mode', 'DevisContrat', 'ServiceVendu', 'TypeRemisecommerciale', 'AlertService'];

    function DevisDialogController($uibModalInstance, $translate, contract, devisId, readOnly, mode, DevisContrat, ServiceVendu, TypeRemisecommerciale, AlertService) {
        var vm = this;

        vm.contract = contract;
        vm.mode = mode || (readOnly ? 'view' : 'edit');
        vm.readOnly = readOnly;
        vm.isSaving = false;
        vm.serviceVendus = [];
        vm.serviceById = {};
        vm.discountServices = [];
        vm.typeRemisecommerciales = [];
        vm.typeRemiseById = {};
        vm.availableStates = [
            { value: 'DRAFT', labelKey: 'wamasysApp.contrat.quote.status.DRAFT' },
            { value: 'SENT', labelKey: 'wamasysApp.contrat.quote.status.SENT' },
            { value: 'ACCEPTED', labelKey: 'wamasysApp.contrat.quote.status.ACCEPTED' },
            { value: 'REFUSED', labelKey: 'wamasysApp.contrat.quote.status.REFUSED' },
            { value: 'CANCELLED', labelKey: 'wamasysApp.contrat.quote.status.CANCELLED' }
        ];
        vm.etatsDevis = [];
        vm.devis = buildDefaultQuote();
        vm.datePickerOpenStatus = {
            dateDevis: false,
            validUntil: false
        };
        vm.lineTotalHt = 0;
        vm.lineTotalTva = 0;
        vm.lineTotalTtc = 0;
        vm.discountTotalHt = 0;
        vm.discountTotalTva = 0;
        vm.discountTotalTtc = 0;

        vm.addLine = addLine;
        vm.removeLine = removeLine;
        vm.addDiscount = addDiscount;
        vm.removeDiscount = removeDiscount;
        vm.onServiceChange = onServiceChange;
        vm.onDiscountServiceChange = onDiscountServiceChange;
        vm.onDiscountTypeChange = onDiscountTypeChange;
        vm.recalculateLine = recalculateLine;
        vm.recalculateDiscount = recalculateDiscount;
        vm.recalculateTotals = recalculateTotals;
        vm.resolveServiceLabel = resolveServiceLabel;
        vm.resolveDiscountTypeLabel = resolveDiscountTypeLabel;
        vm.serviceLabel = serviceLabel;
        vm.statusLabelKey = statusLabelKey;
        vm.dialogTitleKey = dialogTitleKey;
        vm.saveButtonLabelKey = saveButtonLabelKey;
        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.canEditContent = canEditContent;
        vm.canChangeState = canChangeState;

        refreshStateOptions();
        loadServices();
        loadDiscountTypes();
        if (devisId) {
            loadQuote();
        } else {
            recalculateTotals();
        }

        function loadServices() {
            vm.serviceVendus = ServiceVendu.query({ offset: 0, size: 1000 });
            if (vm.serviceVendus.$promise) {
                vm.serviceVendus.$promise.then(function(result) {
                    vm.serviceVendus = result || [];
                    angular.forEach(vm.serviceVendus, function(service) {
                        vm.serviceById[service.id] = service;
                    });
                    updateDiscountServices();
                    recalculateTotals();
                });
            }
        }

        function loadDiscountTypes() {
            vm.typeRemisecommerciales = TypeRemisecommerciale.query({ page: 0, size: 1000, sort: 'libelle,asc' });
            if (vm.typeRemisecommerciales.$promise) {
                vm.typeRemisecommerciales.$promise.then(function(result) {
                    vm.typeRemisecommerciales = result || [];
                    angular.forEach(vm.typeRemisecommerciales, function(typeRemisecommerciale) {
                        vm.typeRemiseById[typeRemisecommerciale.id] = typeRemisecommerciale;
                    });
                    recalculateTotals();
                });
            }
        }

        function loadQuote() {
            DevisContrat.get(contract.id, devisId).then(function(result) {
                vm.devis = result;
                if (vm.mode === 'edit' && vm.devis.etat !== 'DRAFT') {
                    vm.mode = 'status';
                    refreshStateOptions();
                }
                if (!vm.devis.lignes || !vm.devis.lignes.length) {
                    vm.devis.lignes = [buildEmptyLine()];
                }
                vm.devis.remisesCommerciales = vm.devis.remisesCommerciales || [];
                updateDiscountServices();
                recalculateTotals();
            }, function(error) {
                AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalErrorSingle')));
                $uibModalInstance.dismiss('error');
            });
        }

        function buildDefaultQuote() {
            var today = new Date();
            var validUntil = new Date(today.getTime());
            validUntil.setDate(validUntil.getDate() + 30);
            return {
                dateDevis: today,
                validUntil: validUntil,
                etat: 'DRAFT',
                commentaireInterne: null,
                lignes: [buildEmptyLine()],
                remisesCommerciales: []
            };
        }

        function buildEmptyLine() {
            return {
                quantite: 1,
                prixUnitaireHt: 0,
                tauxTva: 0,
                montantHt: 0,
                montantTva: 0,
                montantTtc: 0
            };
        }

        function buildEmptyDiscount() {
            return {
                montantTtc: 0,
                montantHt: 0,
                montantTva: 0,
                tauxTva: 0
            };
        }

        function refreshStateOptions() {
            vm.etatsDevis = vm.availableStates.filter(function(state) {
                return vm.mode !== 'status' || state.value !== 'DRAFT';
            });
        }

        function canEditContent() {
            return !vm.readOnly && vm.mode === 'edit';
        }

        function canChangeState() {
            return !vm.readOnly;
        }

        function dialogTitleKey() {
            if (vm.readOnly) {
                return 'wamasysApp.contrat.quote.viewTitle';
            }
            if (!vm.devis.id) {
                return 'wamasysApp.contrat.quote.createTitle';
            }
            return vm.mode === 'status'
                ? 'wamasysApp.contrat.quote.changeStateTitle'
                : 'wamasysApp.contrat.quote.editTitle';
        }

        function saveButtonLabelKey() {
            return vm.mode === 'status'
                ? 'wamasysApp.contrat.quote.updateState'
                : 'wamasysApp.contrat.quote.save';
        }

        function addLine() {
            if (!canEditContent()) {
                return;
            }
            vm.devis.lignes.push(buildEmptyLine());
            updateDiscountServices();
            recalculateTotals();
        }

        function removeLine(index) {
            if (!canEditContent()) {
                return;
            }
            vm.devis.lignes.splice(index, 1);
            if (!vm.devis.lignes.length) {
                vm.devis.lignes.push(buildEmptyLine());
            }
            updateDiscountServices();
            recalculateTotals();
        }

        function addDiscount() {
            if (!canEditContent()) {
                return;
            }
            vm.devis.remisesCommerciales = vm.devis.remisesCommerciales || [];
            vm.devis.remisesCommerciales.push(buildEmptyDiscount());
            recalculateTotals();
        }

        function removeDiscount(index) {
            if (!canEditContent()) {
                return;
            }
            vm.devis.remisesCommerciales.splice(index, 1);
            recalculateTotals();
        }

        function onServiceChange(line) {
            if (!canEditContent()) {
                return;
            }
            var service = vm.serviceById[line.serviceVenduId];
            if (!service) {
                return;
            }
            line.serviceVenduLabel = serviceLabel(service);
            line.libelle = serviceLabel(service);
            line.prixUnitaireHt = resolveServicePrice(service);
            line.tauxTva = resolveServiceTaxRate(service);
            line.amountPerInstallment = toNullableNumber(service.amountPerInstallment);
            line.totalCredit = toNullableNumber(service.totalCredit);
            updateDiscountServices();
            recalculateLine(line);
        }

        function onDiscountServiceChange(discount) {
            if (!canEditContent()) {
                return;
            }
            discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
            recalculateDiscount(discount);
        }

        function onDiscountTypeChange(discount) {
            var typeRemisecommerciale = vm.typeRemiseById[discount.typeRemisecommercialeId];
            if (!typeRemisecommerciale) {
                return;
            }
            discount.libelle = typeRemisecommerciale.libelle;
            recalculateTotals();
        }

        function recalculateLine(line) {
            line.quantite = positiveOrDefault(line.quantite, 1);
            line.prixUnitaireHt = toNumber(line.prixUnitaireHt);
            line.tauxTva = toNumber(line.tauxTva);
            line.montantHt = round2(line.quantite * line.prixUnitaireHt);
            line.montantTva = round2(line.montantHt * line.tauxTva / 100);
            line.montantTtc = round2(line.montantHt + line.montantTva);
            recalculateTotals();
        }

        function recalculateDiscount(discount) {
            discount.montantTtc = positiveOrZero(discount.montantTtc);
            discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
            discount.montantHt = calculateAmountExclTax(discount.montantTtc, discount.tauxTva);
            discount.montantTva = round2(discount.montantTtc - discount.montantHt);
            recalculateTotals();
        }

        function recalculateTotals() {
            var totalHt = 0;
            var totalTva = 0;
            var totalTtc = 0;
            var discountHt = 0;
            var discountTva = 0;
            var discountTtc = 0;

            updateDiscountServices();

            angular.forEach(vm.devis.lignes || [], function(line, index) {
                line.displayOrder = index;
                line.quantite = positiveOrDefault(line.quantite, 1);
                line.prixUnitaireHt = toNumber(line.prixUnitaireHt);
                line.tauxTva = toNumber(line.tauxTva);
                line.montantHt = round2(line.quantite * line.prixUnitaireHt);
                line.montantTva = round2(line.montantHt * line.tauxTva / 100);
                line.montantTtc = round2(line.montantHt + line.montantTva);
                if (!line.serviceVenduLabel && line.serviceVenduId && vm.serviceById[line.serviceVenduId]) {
                    line.serviceVenduLabel = serviceLabel(vm.serviceById[line.serviceVenduId]);
                }
                totalHt += line.montantHt;
                totalTva += line.montantTva;
                totalTtc += line.montantTtc;
            });

            angular.forEach(vm.devis.remisesCommerciales || [], function(discount, index) {
                discount.displayOrder = index;
                discount.montantTtc = positiveOrZero(discount.montantTtc);
                discount.tauxTva = resolveTaxRateByServiceId(discount.serviceVenduId);
                discount.montantHt = calculateAmountExclTax(discount.montantTtc, discount.tauxTva);
                discount.montantTva = round2(discount.montantTtc - discount.montantHt);
                discount.serviceVenduLabel = resolveDiscountServiceLabel(discount);
                discount.typeRemisecommercialeLabel = resolveDiscountTypeLabel(discount);
                if (!discount.libelle && discount.typeRemisecommercialeLabel) {
                    discount.libelle = discount.typeRemisecommercialeLabel;
                }
                discountHt += discount.montantHt;
                discountTva += discount.montantTva;
                discountTtc += discount.montantTtc;
            });

            vm.lineTotalHt = round2(totalHt);
            vm.lineTotalTva = round2(totalTva);
            vm.lineTotalTtc = round2(totalTtc);
            vm.discountTotalHt = round2(discountHt);
            vm.discountTotalTva = round2(discountTva);
            vm.discountTotalTtc = round2(discountTtc);
            vm.devis.totalHt = round2(totalHt - discountHt);
            vm.devis.totalTva = round2(totalTva - discountTva);
            vm.devis.totalTtc = round2(totalTtc - discountTtc);
        }

        function updateDiscountServices() {
            var uniqueServiceIds = {};
            vm.discountServices = [];
            angular.forEach(vm.devis.lignes || [], function(line) {
                if (!line || !line.serviceVenduId || uniqueServiceIds[line.serviceVenduId]) {
                    return;
                }
                uniqueServiceIds[line.serviceVenduId] = true;
                if (vm.serviceById[line.serviceVenduId]) {
                    vm.discountServices.push(vm.serviceById[line.serviceVenduId]);
                }
            });
        }

        function resolveServiceLabel(line) {
            if (!line) {
                return '';
            }
            if (line.serviceVenduLabel) {
                return line.serviceVenduLabel;
            }
            if (line.serviceVenduId && vm.serviceById[line.serviceVenduId]) {
                return serviceLabel(vm.serviceById[line.serviceVenduId]);
            }
            return '';
        }

        function resolveDiscountServiceLabel(discount) {
            if (!discount) {
                return '';
            }
            if (discount.serviceVenduLabel) {
                return discount.serviceVenduLabel;
            }
            if (discount.serviceVenduId && vm.serviceById[discount.serviceVenduId]) {
                return serviceLabel(vm.serviceById[discount.serviceVenduId]);
            }
            return '';
        }

        function resolveDiscountTypeLabel(discount) {
            if (!discount) {
                return '';
            }
            if (discount.typeRemisecommercialeLabel) {
                return discount.typeRemisecommercialeLabel;
            }
            if (discount.typeRemisecommercialeId && vm.typeRemiseById[discount.typeRemisecommercialeId]) {
                return vm.typeRemiseById[discount.typeRemisecommercialeId].libelle;
            }
            return discount.libelle || '';
        }

        function serviceLabel(service) {
            if (!service) {
                return '';
            }
            return service.clientLabel
                || service.libelle
                || $translate.instant('wamasysApp.contrat.quote.serviceFallback', { id: service.id });
        }

        function statusLabelKey(status) {
            return status ? 'wamasysApp.contrat.quote.status.' + status : '';
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            var invalidDiscount;

            if (!canChangeState()) {
                return;
            }

            vm.devis.lignes = (vm.devis.lignes || []).filter(function(line) {
                return !!line.serviceVenduId;
            });

            if (canEditContent() && !vm.devis.lignes.length) {
                vm.devis.lignes = [buildEmptyLine()];
                AlertService.error($translate.instant('wamasysApp.contrat.quote.lineRequired'));
                return;
            }

            invalidDiscount = (vm.devis.remisesCommerciales || []).some(function(discount) {
                var hasAnyValue = !!(discount.serviceVenduId || discount.typeRemisecommercialeId || positiveOrZero(discount.montantTtc) > 0);
                return hasAnyValue && !isValidDiscount(discount);
            });
            if (canEditContent() && invalidDiscount) {
                AlertService.error($translate.instant('wamasysApp.contrat.quote.discountInvalid'));
                return;
            }

            vm.devis.remisesCommerciales = (vm.devis.remisesCommerciales || []).filter(isValidDiscount);
            recalculateTotals();
            vm.isSaving = true;
            DevisContrat.save(contract.id, vm.devis).then(function(result) {
                vm.isSaving = false;
                $uibModalInstance.close(result);
            }, function(error) {
                vm.isSaving = false;
                AlertService.error(resolveErrorMessage(error, $translate.instant('wamasysApp.contrat.quote.technicalErrorSingle')));
            });
        }

        function openCalendar(dateField) {
            if (!canEditContent()) {
                return;
            }
            vm.datePickerOpenStatus[dateField] = true;
        }

        function isValidDiscount(discount) {
            return !!(discount
                && discount.serviceVenduId
                && discount.typeRemisecommercialeId
                && positiveOrZero(discount.montantTtc) > 0
                && isDiscountServiceAllowed(discount.serviceVenduId));
        }

        function isDiscountServiceAllowed(serviceVenduId) {
            return (vm.discountServices || []).some(function(service) {
                return service.id === serviceVenduId;
            });
        }

        function resolveServicePrice(service) {
            if (!service) {
                return 0;
            }
            if (service.unitPrice !== null && typeof service.unitPrice !== 'undefined') {
                return toNumber(service.unitPrice);
            }
            if (service.typePaiement === 'A_PAYER_AVEC_ECHELONNEMENT' && service.totalCredit !== null && typeof service.totalCredit !== 'undefined') {
                return toNumber(service.totalCredit);
            }
            if (service.amountPerInstallment !== null && typeof service.amountPerInstallment !== 'undefined') {
                return toNumber(service.amountPerInstallment);
            }
            return 0;
        }

        function resolveServiceTaxRate(service) {
            if (!service || !service.typeTax || service.typeTax.taxRate === null || typeof service.typeTax.taxRate === 'undefined') {
                return 0;
            }
            return toNumber(service.typeTax.taxRate);
        }

        function resolveTaxRateByServiceId(serviceVenduId) {
            if (!serviceVenduId || !vm.serviceById[serviceVenduId]) {
                return 0;
            }
            return resolveServiceTaxRate(vm.serviceById[serviceVenduId]);
        }

        function calculateAmountExclTax(amountInclTax, taxRate) {
            var ttc = positiveOrZero(amountInclTax);
            var rate = toNumber(taxRate);
            if (rate <= 0) {
                return round2(ttc);
            }
            return round2(ttc / (1 + rate / 100));
        }

        function round2(value) {
            var numericValue = Number(value || 0);
            return Math.round(numericValue * 100) / 100;
        }

        function positiveOrDefault(value, defaultValue) {
            var numericValue = Number(value);
            return isNaN(numericValue) || numericValue <= 0 ? defaultValue : numericValue;
        }

        function positiveOrZero(value) {
            var numericValue = Number(value);
            return isNaN(numericValue) || numericValue < 0 ? 0 : numericValue;
        }

        function toNumber(value) {
            var numericValue = Number(value);
            return isNaN(numericValue) ? 0 : numericValue;
        }

        function toNullableNumber(value) {
            if (value === null || typeof value === 'undefined' || value === '') {
                return null;
            }
            return toNumber(value);
        }

        function resolveErrorMessage(error, defaultMessage) {
            return error && error.data && error.data.message ? error.data.message : defaultMessage;
        }
    }
})();
